import { render, staticRenderFns } from "./SupplierStatement.vue?vue&type=template&id=027bc2c2&scoped=true"
import script from "./SupplierStatement.vue?vue&type=script&lang=js"
export * from "./SupplierStatement.vue?vue&type=script&lang=js"
import style0 from "./SupplierStatement.vue?vue&type=style&index=0&id=027bc2c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027bc2c2",
  null
  
)

export default component.exports